<div class="row p-1">
  <ng-container *ngFor="let e of distinctElements">
    <div class="col-md-{{cols}}" id="listImg" *ngIf="e.type=='MEDIA' && e.value" class="p-1"[ngClass]="{'hide-print': e?.imprimir === false}" >
    <div class="containerImg" >
        <a [href]="e.value" rel="noopener noreferrer" target="_blank"  class="bg-light img-hover">
          <img class="img-size-6" [src]="e.value" [alt]="e.label" id="{{e.name}}">
          <div class="text-center">{{e.label}}</div>
        </a>
     </div>
    </div>

  </ng-container>
</div>
